import store from './store';

const toBoolean = (x) => !!x;

export const getDeferredPrompt = store.get('deferredPrompt');
export const getIsTourOpen = store.get('isTourOpen', toBoolean);
export const getIsSidebarOpen = store.get('isSidebarOpen', toBoolean);
export const getIsNavigationOpen = store.get('isNavigationOpen', toBoolean);

// TODO: Get rid of

export const getIsActive = store.get('active');
